<template>

  <div class="page">

    <!--Title/Actions-->
    <div class="page-header flex-shrink-0 mb-3 bg-white border-bottom">
      <div class="container-fluid d-flex justify-content-between align-items-center px-md-4 px-3">
        <h3 class="mb-0"><i class="fas fa-id-badge"></i>&nbsp;Vendor Types</h3>
        <div>
          <b-btn @click="showNewVendorTypeModal" class="btn btn-success"><i class="fas fa-plus"></i> Vendor Type</b-btn>
        </div>
      </div>
    </div>

    <!--Search-->
    <div class="container-fluid px-md-4 px-3 py-3 bg-white border-bottom mb-3">
      <div class="row no-gutters">
        <div class="col-lg-4 col-md-6">
          <b-input-group>
            <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
          </b-input-group>
        </div>
        <b-button :disabled="!filter" variant="link" @click="filter = ''">Clear</b-button>
      </div>
    </div>

    <!--Table-->
    <div class="container-fluid flex-grow-1 overflow-auto px-md-4 px-3">
      <div v-if="vendorTypes">
        <b-table id="vendor-types-table" bordered class="mb-5 rg-table" :items="vendorTypeProvider"
          :fields="vendorTypeTableData.fields" no-local-filtering :filter="filter" no-local-sorting
          :sortDesc.sync="sortDesc" :busy.sync="isBusy">
          <template v-slot:cell(name)="data">
            <div class="emphasis">
              {{ data.item.name }}
            </div>
          </template>
          <template v-slot:cell(status)="data">
            <div class="emphasis">
              {{ data.item.active ? "Active" : "Inactive" }}
            </div>
          </template>
          <template v-slot:cell(id)="data">
            <b-btn title="Edit Vendor Types" @click="showEditVendorTypeModal(data.item.id)" variant="link"><i
                class="fas fa-edit"></i></b-btn>
          </template>
        </b-table>
      </div>
    </div>

    <!--Modal-->
    <b-modal v-model="modalOpen" title="Vendor Type" no-close-on-backdrop no-close-on-esc hide-header-close scrollable>
      <div v-if="vendorTypeForEdit">
        <b-form>
          <b-form-group>
            <label>Vendor Type</label>
            <b-form-input placeholder="Name" v-model="vendorTypeForEdit.name" />
          </b-form-group>
          <b-form-group class="mb-1">
            <b-form-checkbox toggle v-model="vendorTypeForEdit.active" switch>Active</b-form-checkbox>
          </b-form-group>
        </b-form>
      </div>
      <template v-slot:modal-footer>
        <b-btn variant="light" @click="toggleModal">Close</b-btn>
        <b-btn variant="primary" @click="SaveVendorType" class="float-right ml-1">Save</b-btn>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'VendorTypes',
  created () {
    this.fields = [
      { key: 'name', label: 'Name', sortable: true },
      { key: 'status', label: 'Status', sortable: true },
      { key: 'id', label: 'Actions' }]
  },
  components: {
  },
  data () {
    return {
      modalOpen: false,
      fields: [],
      isBusy: false,
      showArchived: false,
      sortBy: 'name',
      sortDirection: 'asc',
      filter: null,
      sortDesc: true,
      vendorTypes: [],
      vendorTypeForEdit: null
    }
  },
  computed: {
    vendorTypeTableData () {
      var returnVendorTypes = {
        fields: this.fields
      }
      console.log(
        'Vendor Type Table Data is: ' +
        JSON.stringify(returnVendorTypes, null, 2)
      )
      return returnVendorTypes
    }
  },
  methods: {
    ...mapActions('company', ['getVendorTypes', 'saveVendorType']),
    vendorTypeProvider (ctx) {
      this.isBusy = true
      console.log(
        'vendor type table ctx is: ' +
        JSON.stringify(ctx, null, 2)
      )
      var request = { sortBy: ctx.sortBy, sortDirection: ctx.sortDesc ? 'desc' : 'asc', search: ctx.filter }

      // Must return a promise that resolves to an array of items
      return this.getVendorTypes(request).then(r => {
        // Pluck the array of items off our axios response
        const items = r.data.types
        console.log(
          'Returned Vendor Table Data is: ' +
          JSON.stringify(items, null, 2)
        )
        this.isBusy = false
        this.vendorTypes = items
        // Must return an array of items or an empty array if an error occurred
        return items || []
      })
    },
    toggleModal () {
      this.modalOpen = !this.modalOpen
    },
    async SaveVendorType (data) {
      const newVendorType = this.vendorTypeForEdit
      this.saveVendorType(newVendorType)
        .then(() => {
          this.$root.$emit('bv::refresh::table', 'vendor-types-table')
          this.toggleModal()
          this.$toasted.show('Vendor Type Saved.', {duration: 4000})
        })
    },
    showEditVendorTypeModal (id) {
      let vendorType = this.vendorTypes.find((vt) => vt.id === id)
      this.vendorTypeForEdit = vendorType
      this.toggleModal()
    },
    showNewVendorTypeModal (id) {
      this.vendorTypeForEdit = { name: 'General Contractor', active: true }
      this.toggleModal()
    }
  }
}
</script>

<style>
  .ui.modals.active .modal {
    height: auto;
  }
</style>
